import { MapboxStyles } from 'constants/map';
import SimpleFSM from 'editor/utils/SimpleFSM';
import mapboxgl from 'mapbox-gl';

type StyleStates = 'updated' | 'loading' | 'loaded';

class MapboxMap {
  map: mapboxgl.Map | null = null;

  private _style: MapboxStyles = MapboxStyles.street;

  styleState = new SimpleFSM<StyleStates>('updated', {
    updated: () => 'loading',
    loading: () => 'loaded',
    loaded: () => 'updated',
  });

  get style(): MapboxStyles {
    return this._style;
  }

  set style(nextStyle: MapboxStyles) {
    if (nextStyle !== this._style) {
      this._style = nextStyle;
      this.styleState.reset();
    }
  }
}

export default MapboxMap;
